export const initEquipos = () => {
  const tabs = document.querySelectorAll('.equipos-tabs__tab');
  if (!tabs.length) return;

  const panels = document.querySelectorAll('.equipos-tabs__panel');

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((t) => t.classList.remove('is-active'));
      panels.forEach((p) => p.classList.remove('is-active'));

      tab.classList.add('is-active');
      tab.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      const panel = document.querySelector(
        `.equipos-tabs__panel[data-panel="${tab.dataset.tab}"]`
      );
      panel?.classList.add('is-active');
    });
  });
};
